import { homApi } from '~/redux/apis/hom'
import { CountryDetailsType } from '~/types/common.types'

export const countriesApi = homApi.injectEndpoints({
  endpoints: (builder) => ({
    getAllCountries: builder.query<CountryDetailsType[], void>({
      query: () => ({
        url: '/v1/countries',
        method: 'GET',
      }),
      transformResponse(response: { countries: CountryDetailsType[] }) {
        return response.countries
      },
    }),
  }),
})
export const {
  useGetAllCountriesQuery,
  util: { getRunningQueriesThunk },
} = countriesApi

export const { getAllCountries } = countriesApi.endpoints
